import script from "./VNotify.vue?vue&type=script&setup=true&lang=ts"
export * from "./VNotify.vue?vue&type=script&setup=true&lang=ts"

import "./VNotify.vue?vue&type=style&index=0&id=d7a5e00e&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7a5e00e"]])

export default __exports__